export class SplitByPassengerGroupCriteria {
    paxPerGroup: number;
}
